import { Outlet } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import ScrollToTop from '../../components/ScrollToTop';
import ChatWidget from '../ChatWidget';
import './styles.css';

const Layout = () => {
  const enableChat = !import.meta.env.DEV || String(import.meta.env.VITE_ENABLE_CHAT || '').toLowerCase() === 'true';

  return (
    <div className="layout">
      <Header />
      <main className="flex-grow-1">
        <ScrollToTop />
        <Outlet />
      </main>
      <Footer className="mt-auto" />
      {/* Floating Chat Widget (global) */}
      {enableChat ? <ChatWidget /> : null}
    </div>
  );
};

export default Layout;